// extracted by mini-css-extract-plugin
export var stat_list = "styles-module--stat_list--248Ia";
export var jsAnimInit = "styles-module--jsAnimInit--yeBJs";
export var statitem_number = "styles-module--statitem_number--WfDa0";